import React from "react";
import DATA_PRODUCTS from "./DATA_PRODUCTS";

function Filename(props) {
  // Log each item inside props
  Object.keys(props).forEach(key => {
    // console.log(`Filename script test here: props.${key}:`, props[key]);
  });

  const filenameFormat = {
    fontSize: "2.2em",
    color: "white",
    fontFamily: "Avenir-Heavy"
    // position: "absolute",
    // top: "55px",
  };
  const productNumber = parseInt(props.inputValues.product);
  const company = props.inputValues.client
    ? props.inputValues.client
    : "client";
  const description = props.inputValues.campaign
    ? props.inputValues.campaign
    : "desc";
  const duration = props.inputValues.duration
    ? props.inputValues.duration
    : "dur";
  const countryCode = props.inputValues.countryCode
    ? props.inputValues.countryCode
    : "lang";
  const fsValue = !productNumber
    ? ""
    : DATA_PRODUCTS.data[productNumber].isFS
    ? "_fs"
    : "";
  const partner = props.inputValues.partner
    ? props.inputValues.partner
    : "partner";
  const creativeID = props.inputValues.creativeID
    ? props.inputValues.creativeID
    : "creative";

  const product =
    typeof props.inputValues.product === "undefined"
      ? "prod"
      : DATA_PRODUCTS.data[productNumber].label;

  const eORl = !props.inputValues.platform
    ? "netwk"
    : props.inputValues.platform === "elevator"
    ? "e"
    : "l";
  const directName = `${company}_${duration}_${description}_${countryCode}${fsValue}_${eORl}-${product}`;
  const progNameE = `${creativeID}_${countryCode}${fsValue}_e-${product}`;
  const progNameL = `${creativeID}_${countryCode}${fsValue}_l-${product}`;
  return (
    <div style={{ "text-align": "center" }}>
      <div style={filenameFormat}>
        {props.inputValues.isProgrammatic ? progNameE : directName}
      </div>
      <div
        style={filenameFormat}
        className={`${props.inputValues.isProgrammatic ? "hide" : ""}`}
      >
        {props.inputValues.isProgrammatic ? progNameL : ""}
      </div>
      <div style={{ color: "white" }}>
        {props.inputValues.isProgrammatic
          ? `The file will need to be manually uploaded to S3 in the "advertising/${partner}" folder.`
          : ""}
      </div>
    </div>
  );
}
export default Filename;
